import Vue from 'vue';

/**
 * "SAML" / "OpenID Connect" rather than the stored code. An unknown protocol
 * still renders, as its code in capitals.
 */
export function protocolLabel(vue: Vue, protocol: string): string {
  const key = 'identityIntegrations.protocols.' + protocol;

  return vue.$te(key) ? (vue.$t(key) as string) : protocol.toUpperCase();
}
